$(document).ready(function() {
    
    if (window.innerWidth < 768) {
        $.fancybox.open({
            toolbar: false,
            width: 350,
            touch: false,
            smallBtn: true,
            baseClass: 'login-popup',
            src: "https://cdn.shopify.com/s/files/1/0650/8947/0713/files/w_2.webp?v=1770304384",
            type: "image",
            clickContent: false,
            wheel: false,
            afterShow: function(instance, slide) {
                // Custom HTML element append करें
                $('.login-popup .fancybox-content').append(`
                    <a class='fancybox-link' href='${accountUrl}'></a>
                `);
            },
            animationEffect: false
        });
    }else{
        $.fancybox.open({
            toolbar: false,
            width: 1200,
            touch: false,
            smallBtn: true,
            baseClass: 'login-popup',
            src: "https://cdn.shopify.com/s/files/1/0650/8947/0713/files/w.webp",
            type: "image",
            clickContent: false,
            wheel: false,
            afterShow: function(instance, slide) {
                // Custom HTML element append करें
                $('.login-popup .fancybox-content').append(`
                    <a class="fancybox-link" href="${accountUrl}"></a>
                `);
            },
            animationEffect: false
        });
    }
});